import React, { useState, useEffect } from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "wowjs/css/libs/animate.css"; // WOW.js animations
import "../App.css";
import WOW from "wowjs";
import { FaArrowCircleRight } from "react-icons/fa"; // Rotation icon
import Banner from "../components/Banner"; // Banner Component
import bannerImage from "../images/game.jpeg"; // Banner Image
import Sumit from "../images/Sumit_mandale.jpeg";
// import Anand from "../images/profile.png";
// import Ankit from "../images/profile.png";
// import Dinesh from "../images/profile.png";
// import Bhushan from "../images/profile.png";
// import Abhijeet from "../images/profile.png";
// import Antara from "../images/profile.png";

const OurTeamCard = () => {
  const [activeTab, setActiveTab] = useState("general-info");
  

  const generalInfoContent = [
    "Dr. Sumit Suresh Mandale is a passionate adventurer who has dedicated his life to mountaineering and outdoor exploration.",
    "He is an expert outdoor instructor, teaching mountaineering, rock climbing, and other adventure sports.",
    "His achievements as a mountaineer include summiting some of the highest peaks in the world, contributing significantly to the global mountaineering community.",
    "Beyond his mountaineering pursuits, Dr. Mandale is a creator of the 'Challenge of Everest' board game, a tool designed to inspire adventure and educate people about the challenges of mountaineering.",
    "Author of Marathi book 'Yashogatha Annapurna chi'.",
    "11 years of experience in High Altitude medicine.",
    "Participated in mountain rescue and body recovery missions in Sahyadri and Himalayas.",
    "Participated in Nepal earthquake (2015) and Mahad flood relief work (2021).",
    "20 years of experience in trekking in Sahyadri.",
    "Five-time winner of Enduro3 adventure race."
  ];

  const successStories = [
    "Summited Mt. Kanchenjunga, world's third highest peak (May 2019)",
    "Summited Mt. Cho Oyu, world's sixth highest peak (May 2016)",
    "Summited Mt. Annapurna, world's tenth highest peak (April 2021)",
    "Summited Mt. Kun 7077 meters (July 2017)",
    "Summited Mt. Manda 1 6539 meters (September 2018)",
    "Summited Mt. Mera 6476 meters (April 2017 and October 2019)",
    "Summited Mt. Stok Kangri 6153 meters (July 2015 and August 2018)",
    "Summited Mt. Yunam 6129 meters (August 2022)",
    "Summited Mt. Ut Kangri 6123 meters (August 2024)",
    "Summited Mt. Kangyatse 6221 meters (July 2024)"
  ];

  const rockClimbingAchievements = [
    "First Ascent of 250 ft high 'Shivgiri' route at Jivdhan fort (December 2016)",
    "First Ascent of 300 ft high 'Hadsar Republic' route at Hadsar fort (January 2018)",
    "First Ascent of 400 ft high 'Arunodaya' route at Mandangad fort (December 2019)",
    "First Ascent of 180 ft high 'Warm Up' route at Jivdhan fort (January 2020)",
    "First Ascent of 100 ft high 'Kalamjai' route at Nira pinnacle (December 2020)"
  ];

  const technicalTeam = [
    { name: "Anand Mali", achievements: "Mt.Everest, Kangchenjunga, Mt. Nun Summiter",  },
    { name: "Ankit Sohoni", achievements: "Mt. Bhrigu, Mt. Kilimanjaro Summiter (Artwork and Graphics Design)",  },
    { name: "Dinesh Kotkar", achievements: "Mt. Kun and Mt. Nalini Summiter", },
    { name: "Bhushan Shet", achievements: "Mt. Nalini Summiter and Rock Climber Mountaineer",  },
    { name: " Abhijit Deshmukh", achievements: "Mountaineer", },
    { name: "Antara Joshi", achievements: "Rock Climber", }
  ];

  const mentors = [
    { name: "Abhijit Joshi", },
    { name: "Asawari Joshi", },
    { name: "Dr. Kedar Joshi",},
    { name: "Dhanesh Gandhi", },
    { name: "Medha Medsikar",  },
    { name: " Charuta Palsodkar",  },
    { name: "Shashikant Soman",  }
  ];

  const specialThanks = [
    "Dinesh Kotkar",
    "Jitendra Gavare",
    "Bhagwan Chawale",
    "Mingma Sherpa Darjeeling"
  ];

  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  return (
    <>
      {/* Banner Section */}
      <Banner
        bannerImage={bannerImage}
        title="Our Team"
        style={{
          height: "450px",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
      />

      {/* Profile Section */}
      <div className="container mt-5">
        <div className="row align-items-center">
          <div className="col-md-4 wow fadeInLeft" data-wow-duration="1s">
            <img
              src={Sumit}
              alt="Dr. Sumit Suresh Mandale"
              className="img-fluid rounded"
              style={{ width: "100%", height: "490px", objectFit: "cover" }}
            />
          </div>
          <div className="col-md-8 wow fadeInRight" data-wow-duration="1s">
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
              <Tab eventKey="general-info" title="About">
                <ul>
                  {generalInfoContent.map((info, index) => (
                    <li key={index}>{info}</li>
                  ))}
                </ul>
              </Tab>
              <Tab eventKey="success-stories" title="Success Stories">
                <ul>
                  {successStories.map((story, index) => (
                    <li key={index}>
                      <FaArrowCircleRight className="me-2" />
                      {story}
                    </li>
                  ))}
                </ul>
              </Tab>
              <Tab eventKey="rock-climbing" title="Rock Climbing Achievements">
                <ul>
                  {rockClimbingAchievements.map((achievement, index) => (
                    <li key={index}>
                      <FaArrowCircleRight className="me-2" />
                      {achievement}
                    </li>
                  ))}
                </ul>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>

      {/* Technical Team Section */}
      <div className="container mt-5">
        <h2 className="text-center">Technical Team</h2>
        <div className="row">
          {technicalTeam.map((member, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="card text-center h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{member.name}</h5>
                  <p className="card-text">{member.achievements}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mentors Section */}
      <div className="container mt-5">
        <h2 className="text-center">Mentors</h2>
        <div className="row">
          {mentors.map((mentor, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{mentor.name}</h5>
                  <p className="card-text">{mentor.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Special Thanks Section */}
      <div className="container mt-5">
        <h2 className="text-center">Special Thanks To</h2>
        <div className="row">
          {specialThanks.map((thanks, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body text-center">
                  <h5 className="card-title">{thanks}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Event Partner Section */}
      <div className="container mt-5">
        <h2 className="text-center">Event Partner</h2>
        <p className="text-center text-primary">
          <strong>Royal Touch Event, Pune</strong>
        </p>
      </div>
    </>
  );
};

export default OurTeamCard;
